export type ContentStatus =
  | { kind: 'loading'; label: string }
  | { kind: 'empty'; title: string; body: string }
  | { kind: 'no-match'; title: string }
  | { kind: 'list' };

/** What Content shows for the posts currently loaded. A further page keeps the grid. */
export function contentStatus(loading: boolean, query: string, count: number): ContentStatus {
  if (count === 0 && loading) {
    return { kind: 'loading', label: 'Loading posts…' };
  }
  if (count === 0 && query.trim().length > 0) {
    return { kind: 'no-match', title: 'No posts match' };
  }
  if (count === 0) {
    return {
      kind: 'empty',
      title: 'No posts found yet',
      body: 'Matching posts appear here once we find them.',
    };
  }
  return { kind: 'list' };
}

/**
 * Total published posts, including Stories, from unfiltered page lengths.
 * A full last page means another page may exist, so the total is not known yet.
 */
export function countFromPages(pageLengths: readonly number[], pageSize: number): number | null {
  let total = 0;
  for (const length of pageLengths) {
    total += length;
    if (length < pageSize) {
      return total;
    }
  }
  return null;
}

export const POSTS_FOUND_PAGE = 100;
